export function toIDR(val, prefix = '.', hideSymbol = false) {
  const currencyString = hideSymbol ? '' : 'Rp';
  const formatted = (val / 1).toFixed(0).replace('.', '');
  return `${currencyString}${formatted
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, prefix)}`;
}

export const toFormatPriceWithPrefix = amount => {
  const MILLION = 1000000;
  const THOUSAND = 1000;

  const isCleanlyDivisible = (value, divisor) => value % divisor === 0;

  if (amount >= MILLION) {
    const valueInMillions = amount / MILLION;
    const decimalPlaces = isCleanlyDivisible(amount, MILLION) ? 0 : 1;
    return `${Number(valueInMillions.toFixed(decimalPlaces))} juta`;
  }

  if (amount >= THOUSAND) {
    const valueInThousands = amount / THOUSAND;
    const decimalPlaces = isCleanlyDivisible(amount, THOUSAND) ? 0 : 1;
    return `${Number(valueInThousands.toFixed(decimalPlaces))} ribu`;
  }

  return amount.toString();
};
